import type { Diary } from './types';

export type DiaryFilter = 'all' | 'starred' | 'attachments';
export type DiarySort = 'date-desc' | 'size-desc' | 'size-asc';

export function sortDiaries(diaries: Diary[], mode: DiarySort = 'date-desc'): Diary[] {
  return [...diaries].sort((a, b) => {
    if (mode === 'size-desc') return b.storageBytes - a.storageBytes || Date.parse(b.createdAt) - Date.parse(a.createdAt);
    if (mode === 'size-asc') return a.storageBytes - b.storageBytes || Date.parse(b.createdAt) - Date.parse(a.createdAt);
    return Date.parse(b.createdAt) - Date.parse(a.createdAt);
  });
}

export function filterDiaries(diaries: Diary[], query: string, filter: DiaryFilter): Diary[] {
  const q = query.trim().toLocaleLowerCase('zh-CN');
  return diaries.filter((diary) => {
    const matchesQuery = !q || `${diary.title} ${diary.body}`.toLocaleLowerCase('zh-CN').includes(q);
    const matchesFilter = filter === 'all' || (filter === 'starred' && diary.starred) || (filter === 'attachments' && diary.attachments.some((item) => item.available));
    return matchesQuery && matchesFilter;
  });
}
